import axios from './http';
import global from '@/constants/Global.constants'

export default {
  findAllUser (params) {
    return axios.post(global.BASE_ACL + '/user/findAllUserInfo', params);
  },
  getDataDict (params) {
    return axios.post(global.DMZ_BASE + '/common/getDictInfoList', params)
  },
  getProvince (params) { // 获取省级数据
    return axios.post(global.BASE_INFO + '/pca/findProvince', params)
  },
  getCity (params) { // 获取市级数据
    return axios.post(global.BASE_INFO + '/pca/findCity', params)
  },
  getArea (params) { // 获取区级数据
    return axios.post(global.BASE_INFO + '/pca/findArea', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/base.js